import axios from "axios";
import { API_HOST } from "../BaseUrl"
import client, { headers } from "./config"
import { encrypt, generateHMAC } from "../../Utils/hmac";
import api from "./sessionExpiryAxios";

// please note : there is a difference between axios and client imported instances

export const refreshToken = async (token, email) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `user/refresh-token`, { token, email }, { headers })
            if (response.status === 200) {
                const { jwtToken, ...user } = response.data.data
                localStorage.setItem('user', JSON.stringify(user))
                localStorage.setItem('authToken', jwtToken)
                resolve(response)
            }
            reject(response)

        } catch (error) {
            logoutService()
            reject(error)
        }
    })

}

export const LoginService = async (data) => {
    const hmac = await generateHMAC();
    const _n = encrypt(data);
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `claraview/clinics/login`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }

    })

}

export const consumeOnboardingLink = async (token) => {
    const hmac = await generateHMAC();
    const _n = encrypt({ token });
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `claraview/clinics/onboarding/consume`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }

    })

}

export const logoutService = () => {
    const token = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).token : ''
    const updatedHeaders = { ...headers, Authorization: localStorage.getItem("authToken") }

    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.put(API_HOST + `user/logout`, { token }, { headers: updatedHeaders })
            if (response.status === 200) {
                localStorage.clear()
                resolve(response)
            }
            localStorage.clear()
            reject(response)

        } catch (error) {
            localStorage.clear()
            reject(error)
        }
    })
}


export const registerUser = async (data) => {
    const hmac = await generateHMAC();
    const _n = encrypt(data);
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };
    return new Promise(async (resolve, reject) => {
        try {

            const response = await axios.post(
                API_HOST + `claraview/clinics/create`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 201) {
                resolve(response)
            }
            reject(response)

        }
        catch (error) {
            reject(error)
        }
    })
}

export const ValidateOtp = async (data) => {
    const hmac = await generateHMAC();
    const _n = encrypt(data);
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `claraview/clinics/verify-email`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

export const resendVerificationOtp = async (data) => {
    const hmac = await generateHMAC();
    const _n = encrypt(data);
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `claraview/clinics/verify-email/resend`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

export const forgotPassword = async (data) => {
    const hmac = await generateHMAC();
    const _n = encrypt(data);
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `claraview/clinics/forgot-password`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

export const resendResetOtp = async (data) => {
    const hmac = await generateHMAC();
    const _n = encrypt(data);
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `claraview/clinics/resend-reset-otp`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

export const verifyResetOtp = async (data) => {
    const hmac = await generateHMAC();
    const _n = encrypt(data);
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `claraview/clinics/verify-otp`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

export const resetPassword = async (data) => {
    const hmac = await generateHMAC();
    const _n = encrypt(data);
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `claraview/clinics/reset-password`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

export const getClinicProfile = async () => {
    const hmac = await generateHMAC();
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };

    return new Promise(async (resolve, reject) => {
        try {
            const response = await api.get(
                API_HOST + `claraview/clinics/me`,
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

export const updateClinicProfile = async (data) => {
    const hmac = await generateHMAC();
    const _n = encrypt(data);
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
    };

    return new Promise(async (resolve, reject) => {
        try {
            const response = await api.put(
                API_HOST + `claraview/clinics/update`,
                { _n },
                { headers: updatedHeaders }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

export const changePassword = (data) => {
    const updatedHeaders = { ...headers, Authorization: localStorage.getItem("authToken") }

    return new Promise(async (resolve, reject) => {
        try {
            const response = await client.post(API_HOST + `user/changePassword`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)

        } catch (error) {
            reject(error)
        }
    })
}

